/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<rect
				opacity="0.4"
				x="9"
				y="9"
				width="6"
				height="6"
				rx="3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M5.10686 18.8643C3.9738 18.1845 3.40727 17.8446 2.99575 17.3766C2.63158 16.9624 2.35699 16.4774 2.18922 15.9521C1.99963 15.3584 1.99963 14.6978 1.99963 13.3764L1.99963 10.6236C1.99963 9.30225 1.99963 8.64157 2.18922 8.04791C2.35699 7.52256 2.63158 7.03758 2.99575 6.62342C3.40726 6.15542 3.9738 5.8155 5.10686 5.13566L8.70686 2.97566C9.90406 2.25734 10.5027 1.89818 11.1417 1.75786C11.7069 1.63373 12.2924 1.63373 12.8576 1.75786C13.4966 1.89818 14.0952 2.25734 15.2924 2.97566L18.8924 5.13566C20.0255 5.8155 20.592 6.15542 21.0035 6.62342C21.3677 7.03758 21.6423 7.52256 21.81 8.04791C21.9996 8.64156 21.9996 9.30225 21.9996 10.6236V13.3764C21.9996 14.6978 21.9996 15.3584 21.81 15.9521C21.6423 16.4774 21.3677 16.9624 21.0035 17.3766C20.592 17.8446 20.0255 18.1845 18.8924 18.8643L15.2924 21.0243C14.0952 21.7427 13.4966 22.1018 12.8576 22.2421C12.2924 22.3663 11.7069 22.3663 11.1417 22.2421C10.5027 22.1018 9.90406 21.7427 8.70686 21.0243L5.10686 18.8643Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.99575 17.3765C3.40727 17.8446 3.9738 18.1845 5.10686 18.8643L8.70686 21.0243C9.90406 21.7426 10.5027 22.1018 11.1417 22.2421C11.7069 22.3662 12.2924 22.3662 12.8576 22.2421C13.4966 22.1018 14.0952 21.7426 15.2924 21.0243L18.8924 18.8643C20.0255 18.1845 20.592 17.8446 21.0035 17.3765C21.3677 16.9624 21.6423 16.4774 21.81 15.9521C21.9996 15.3584 21.9996 14.6977 21.9996 13.3764V10.6236C21.9996 9.30222 21.9996 8.64154 21.81 8.04788C21.6423 7.52253 21.3677 7.03755 21.0035 6.6234C20.592 6.15539 20.0255 5.81547 18.8924 5.13563L15.2924 2.97564C14.0952 2.25732 13.4966 1.89816 12.8576 1.75783C12.2924 1.6337 11.7069 1.6337 11.1417 1.75783C10.5027 1.89816 9.90406 2.25732 8.70686 2.97564L5.10686 5.13564C3.9738 5.81547 3.40726 6.15539 2.99575 6.6234C2.63158 7.03755 2.35699 7.52253 2.18922 8.04788C1.99963 8.64154 1.99963 9.30222 1.99963 10.6236V13.3764C1.99963 14.6977 1.99963 15.3584 2.18922 15.9521C2.35699 16.4774 2.63158 16.9624 2.99575 17.3765ZM12 8.99997C10.3431 8.99997 9 10.3431 9 12C9 13.6568 10.3431 15 12 15C13.6569 15 15 13.6568 15 12C15 10.3431 13.6569 8.99997 12 8.99997Z"
				fill="currentColor"
			/>
			<path
				d="M5.10686 18.8643C3.9738 18.1845 3.40727 17.8446 2.99575 17.3766C2.63158 16.9624 2.35699 16.4774 2.18922 15.9521C1.99963 15.3584 1.99963 14.6978 1.99963 13.3764L1.99963 10.6236C1.99963 9.30225 1.99963 8.64157 2.18922 8.04791C2.35699 7.52256 2.63158 7.03758 2.99575 6.62342C3.40726 6.15542 3.9738 5.8155 5.10686 5.13566L8.70686 2.97566C9.90406 2.25734 10.5027 1.89818 11.1417 1.75786C11.7069 1.63373 12.2924 1.63373 12.8576 1.75786C13.4966 1.89818 14.0952 2.25734 15.2924 2.97566L18.8924 5.13566C20.0255 5.8155 20.592 6.15542 21.0035 6.62342C21.3677 7.03758 21.6423 7.52256 21.81 8.04791C21.9996 8.64156 21.9996 9.30225 21.9996 10.6236V13.3764C21.9996 14.6978 21.9996 15.3584 21.81 15.9521C21.6423 16.4774 21.3677 16.9624 21.0035 17.3766C20.592 17.8446 20.0255 18.1845 18.8924 18.8643L15.2924 21.0243C14.0952 21.7427 13.4966 22.1018 12.8576 22.2421C12.2924 22.3663 11.7069 22.3663 11.1417 22.2421C10.5027 22.1018 9.90406 21.7427 8.70686 21.0243L5.10686 18.8643Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.24969 11.105C1.24969 9.4533 1.24969 8.62745 1.48668 7.88537C1.69639 7.22868 2.03963 6.62246 2.49484 6.10477C3.00923 5.51977 3.7174 5.09487 5.13373 4.24507L7.88373 2.59507C9.38023 1.69717 10.1285 1.24822 10.9273 1.07281C11.6338 0.917651 12.3656 0.917651 13.0721 1.07281C13.8709 1.24822 14.6192 1.69717 16.1157 2.59507L18.8657 4.24507C20.282 5.09487 20.9902 5.51976 21.5046 6.10477C21.9598 6.62246 22.303 7.22868 22.5127 7.88537C22.7497 8.62744 22.7497 9.4533 22.7497 11.105V12.8953C22.7497 14.547 22.7497 15.3728 22.5127 16.1149C22.303 16.7716 21.9598 17.3778 21.5046 17.8955C20.9902 18.4805 20.282 18.9054 18.8657 19.7552L16.1157 21.4052C14.6192 22.3031 13.8709 22.752 13.0721 22.9275C12.3656 23.0826 11.6338 23.0826 10.9273 22.9275C10.1285 22.752 9.38023 22.3031 7.88373 21.4052L5.13373 19.7552C3.7174 18.9054 3.00923 18.4805 2.49484 17.8955C2.03963 17.3778 1.69639 16.7716 1.48668 16.1149C1.24969 15.3728 1.24969 14.547 1.24969 12.8952V11.105ZM12 8.99999C10.3431 8.99999 8.99998 10.3431 8.99998 12C8.99998 13.6568 10.3431 15 12 15C13.6568 15 15 13.6568 15 12C15 10.3431 13.6568 8.99999 12 8.99999Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M19 5.20307C20.3215 6.0104 21.0491 6.5321 21.4804 7.29388C21.9996 8.21088 21.9996 9.31707 21.9996 11.5294V12.4704C21.9996 14.6828 21.9996 15.7889 21.4804 16.7059C20.9612 17.623 20.0127 18.1921 18.1156 19.3303L16.1156 20.5303C14.1102 21.7335 13.1076 22.3351 11.9996 22.3351C10.8917 22.3351 9.88902 21.7335 7.88367 20.5303L5.88367 19.3303C3.98658 18.1921 3.03804 17.623 2.51883 16.7059C1.99963 15.7889 1.99963 14.6828 1.99963 12.4704L1.99963 11.5294C1.99963 9.31707 1.99963 8.21088 2.51883 7.29388C3.03803 6.37687 3.98658 5.80774 5.88367 4.66949L7.88367 3.46949C9.88902 2.26628 10.8917 1.66467 11.9996 1.66467C13.0861 1.66467 14.0713 2.24316 16 3.40014M12 9.00012C13.6569 9.00012 15 10.3433 15 12.0001C15 13.657 13.6569 15.0001 12 15.0001C10.3431 15.0001 9 13.657 9 12.0001C9 11.6495 9.06015 11.3129 9.17071 11.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M5.10686 18.8643C3.9738 18.1845 3.40727 17.8446 2.99575 17.3766C2.63158 16.9624 2.35699 16.4774 2.18922 15.9521C1.99963 15.3584 1.99963 14.6978 1.99963 13.3764L1.99963 10.6236C1.99963 9.30225 1.99963 8.64157 2.18922 8.04791C2.35699 7.52256 2.63158 7.03758 2.99575 6.62342C3.40726 6.15542 3.9738 5.8155 5.10686 5.13566L8.70686 2.97566C9.90406 2.25734 10.5027 1.89818 11.1417 1.75786C11.7069 1.63373 12.2924 1.63373 12.8576 1.75786C13.4966 1.89818 14.0952 2.25734 15.2924 2.97566L18.8924 5.13566C20.0255 5.8155 20.592 6.15542 21.0035 6.62342C21.3677 7.03758 21.6423 7.52256 21.81 8.04791C21.9996 8.64156 21.9996 9.30225 21.9996 10.6236V13.3764C21.9996 14.6978 21.9996 15.3584 21.81 15.9521C21.6423 16.4774 21.3677 16.9624 21.0035 17.3766C20.592 17.8446 20.0255 18.1845 18.8924 18.8643L15.2924 21.0243C14.0952 21.7427 13.4966 22.1018 12.8576 22.2421C12.2924 22.3663 11.7069 22.3663 11.1417 22.2421C10.5027 22.1018 9.90406 21.7427 8.70686 21.0243L5.10686 18.8643Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.24976 11.105C1.24976 9.4533 1.24976 8.62745 1.48674 7.88537C1.69645 7.22868 2.03969 6.62246 2.4949 6.10477C3.00929 5.51977 3.71746 5.09487 5.13379 4.24507L7.88379 2.59507C9.38029 1.69717 10.1285 1.24822 10.9273 1.07281C11.6339 0.917651 12.3657 0.917651 13.0722 1.07281C13.871 1.24822 14.6192 1.69717 16.1157 2.59507L18.8657 4.24507C20.2821 5.09487 20.9902 5.51976 21.5046 6.10477C21.9598 6.62246 22.3031 7.22868 22.5128 7.88537C22.7498 8.62744 22.7498 9.4533 22.7498 11.105V12.8953C22.7498 14.547 22.7498 15.3728 22.5128 16.1149C22.3031 16.7716 21.9598 17.3778 21.5046 17.8955C20.9902 18.4805 20.2821 18.9054 18.8657 19.7552L16.1157 21.4052C14.6192 22.3031 13.871 22.752 13.0722 22.9275C12.3657 23.0826 11.6339 23.0826 10.9273 22.9275C10.1285 22.752 9.38029 22.3031 7.8838 21.4052L5.13379 19.7552C3.71746 18.9054 3.00929 18.4805 2.4949 17.8955C2.03969 17.3778 1.69645 16.7716 1.48674 16.1149C1.24976 15.3728 1.24976 14.547 1.24976 12.8952V11.105Z"
				fill="currentColor"
			/>
			<path
				d="M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
